/**
 * @voltxampere/web — Probe binding store (Sprint 15)
 *
 * Computed view over the channel store: maps each probed netId to
 * the channel that owns it. Lets the canvas overlay paint a probe
 * dot at every bound net without iterating the channel list per
 * frame, and the inspector net mode read "is this net currently
 * probed?" in O(1).
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { computed, type ReadonlySignal } from "@preact/signals-core";
import type { ChannelId } from "@voltxampere/ui/waveform";

import { channels, getFirstAvailableProbeChannel } from "./channels.js";

export const probeBindings: ReadonlySignal<ReadonlyMap<string, ChannelId>> = computed(() => {
  const out = new Map<string, ChannelId>();
  for (const [id, state] of channels.value) {
    if (state.probeBinding !== null) {
      out.set(state.probeBinding, id);
    }
  }
  return out;
});

export function getNetChannel(netId: string): ChannelId | null {
  return probeBindings.value.get(netId) ?? null;
}

export function getFirstAvailableChannel(): ChannelId | null {
  return getFirstAvailableProbeChannel();
}
